var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('pageHeader',{attrs:{"actNum":0,"bannerImg":_vm.bannerImg,"bannerText":"- Innovation","bannerText2":"Smart healthcare"}}),_c('homeBusiness'),_c('homeSolution'),_c('homeNews'),_c('footPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }